import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Box } from 'foundations-components/transitional/components/Box';
import { Section } from 'foundations-components/transitional/components/Section';
import { HR } from 'foundations-components/transitional/components/HR';
import { View } from 'foundations-components/components/View';

// @ts-expect-error Untyped import
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../lib/usageTracker';
import { SUITE_LEARNING_RESOURCES, isKnowledgeBaseResource } from '../../config/learningResources';
import FeedbackLink from '../analyticsSuites/FeedbackLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResourceLink = ({
  children,
  resource,
  suiteId
}) => {
  const handleClick = useCallback(() => trackEvent(EVENTS.clickLearnAboutReportingCard, {
    source: resource.title,
    interactionSource: suiteId
  }), [resource.title, suiteId]);
  if (isKnowledgeBaseResource(resource)) {
    return /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: handleClick,
      url: resource.path,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    href: resource.path,
    onClick: handleClick,
    children: children
  });
};
const AnalyticsSuitesSideWidget = ({
  feedbackClient,
  suiteId
}) => {
  const learningResources = SUITE_LEARNING_RESOURCES[suiteId];
  if (!learningResources || learningResources.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Box, {
    basis: 250,
    shrink: 0,
    paddingBlockStart: "400",
    paddingBlockEnd: "600",
    paddingInlineStart: "600",
    paddingInlineEnd: "0",
    maxInlineSize: "30%",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.collectionHomes.sideWidget.header"
      })
    }), learningResources.map((resource, index) => /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "300",
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(ResourceLink, {
        resource: resource,
        suiteId: suiteId,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: resource.title
        })
      })
    }, index)), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(FeedbackLink, {
        feedbackClient: feedbackClient
      })
    })]
  });
};
export default AnalyticsSuitesSideWidget;